import { configureStore } from "@reduxjs/toolkit";
import formReducer from "./formSlice";
import ViewFormReducer from "./ViewFormSlice";
import ClientformReducer from "./ClientFormSlice";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage/session";
import { combineReducers } from "redux";
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["form", "Viewform", "Clientform"],
};

const rootReducer = combineReducers({
  form: formReducer,
  Viewform: ViewFormReducer,
  Clientform: ClientformReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          "file/upload",
        ], // Ignore persist actions
        ignoredPaths: ["file.tempData"], // Ignore specific state paths
      },
    }),
});

export const persistor = persistStore(store);
